/* ===============================
   SIBLING SWATCH INIT (PLP)
================================ */

function renderSiblings(container, siblings, currentHandle) {
  const grid = container.querySelector('.collection-siblings__grid');
  const activeColorEl = container.querySelector('.active-color');
  const countEl = container.querySelector('.sibling-count');
  const previousButton = grid?.querySelector('.sibling-carousel-button--previous');
  const nextButton = grid?.querySelector('.sibling-carousel-button--next');

  if (!grid || !siblings.length || !previousButton || !nextButton) return;

  if (countEl && container.dataset.showSiblingCount === 'true') {
    const colorCount = siblings.length;
    countEl.textContent = `${colorCount} ${colorCount === 1 ? 'Color' : 'Colors'}`;
  }

  const active = siblings.find(product => product.handle === currentHandle);
  const activeColor = active?.title.split('|').pop().trim() || '';
  if (activeColorEl && container.dataset.showSiblingColorName === 'true') {
    activeColorEl.textContent = activeColor;
  }

  const sorted = [...siblings].sort((a, b) => {
    if (a.handle === currentHandle) return -1;
    if (b.handle === currentHandle) return 1;
    return 0;
  });

  const renderSwatches = products => {
    grid.replaceChildren(previousButton, nextButton);

    products.forEach(product => {
      const isActive = product.handle === currentHandle;
      const color = product.title.split('|').pop().trim();
      const swatch = document.createElement(isActive ? 'div' : 'button');
      swatch.className = `sibling-swatch${isActive ? ' active' : ' sibling-link'}`;

      if (!isActive) {
        swatch.type = 'button';
        const collectionHandle = container.dataset.collection;
        swatch.dataset.url = collectionHandle
          ? `/collections/${collectionHandle}/products/${product.handle}`
          : `/products/${product.handle}`;
      }

      const image = document.createElement('img');
      image.src = product.image.replace(/(\.(jpg|jpeg|png|webp))/i, '_120x$1');
      image.alt = product.title;
      const imageWrap = document.createElement('div');
      imageWrap.className = 'fix_transparent_image_collection_sibling';
      imageWrap.appendChild(image);
      swatch.appendChild(imageWrap);

      if (activeColorEl && container.dataset.showSiblingColorName === 'true') {
        swatch.addEventListener('mouseenter', () => activeColorEl.textContent = color);
        swatch.addEventListener('mouseleave', () => activeColorEl.textContent = activeColor);
      }

      grid.insertBefore(swatch, nextButton);
    });
  };

  let page = 0;
  const firstPageSize = 4;
  const pageSize = 3;

  const renderPage = () => {
    const useDesktopCarousel = container.dataset.enableDesktopCarousel === 'true'
      && window.matchMedia('(min-width: 750px)').matches
      && sorted.length > 5;

    container.classList.toggle('sibling-carousel', useDesktopCarousel);

    if (!useDesktopCarousel) {
      page = 0;
      grid.dataset.carouselPage = '';
      previousButton.classList.remove('visible');
      nextButton.classList.remove('visible');
      renderSwatches(sorted);
      return;
    }

    const maxPage = Math.ceil((sorted.length - firstPageSize) / pageSize);
    page = Math.min(page, maxPage);
    const start = page === 0 ? 0 : firstPageSize + (page - 1) * pageSize;
    const end = Math.min(start + (page === 0 ? firstPageSize : pageSize), sorted.length);
    const remaining = sorted.length - end;

    grid.dataset.carouselPage = page === 0 ? 'first' : 'next';
    renderSwatches(sorted.slice(start, end));

    previousButton.classList.toggle('visible', page > 0);
    nextButton.classList.toggle('visible', remaining > 0);
    nextButton.textContent = remaining > 0 ? `+${remaining}` : '';
    nextButton.setAttribute('aria-label', remaining > 0 ? `Next ${remaining} colors` : 'Next colors');
  };

  previousButton.onclick = event => {
    event.preventDefault();
    event.stopPropagation();
    if (page > 0) {
      page -= 1;
      renderPage();
    }
  };

  nextButton.onclick = event => {
    event.preventDefault();
    event.stopPropagation();
    const pageEnd = page === 0 ? firstPageSize : firstPageSize + page * pageSize;
    if (pageEnd < sorted.length) {
      page += 1;
      renderPage();
    }
  };

  container._renderSiblingPage = renderPage;
  renderPage();
}

if (!window.PLP_SIBLING_RESIZE_BOUND) {
  window.PLP_SIBLING_RESIZE_BOUND = true;
  window.addEventListener('resize', () => {
    document.querySelectorAll('.collection-siblings').forEach(container => {
      container._renderSiblingPage?.();
    });
  });
}

async function initSiblingSwatches(context = document) {
  const cards = context.querySelectorAll('.collection-siblings');
  if (!cards.length) return;

  const cache = window.__SIBLING_CACHE__ || (window.__SIBLING_CACHE__ = {});

  for (const card of cards) {
    if (card.dataset.initialized === 'true') continue;
    card.dataset.initialized = 'true';

    const familyCode     = card.dataset.family;   // 03426
    const sizeCode       = card.dataset.size;     // xw / m / w
    const currentHandle  = card.dataset.handle;
    const productType    = card.dataset.type;
    const plpComingSoon  = card.dataset.comingSoon === 'true';

    if (!familyCode || !currentHandle) continue;

    /* "plp" namespace keeps this separate from siblings-pdp.js, which
       stores a different object shape under the same family/size.
       Increment CACHE_VERSION when the stored object shape changes. */
    const CACHE_VERSION = '2';

    const cacheKey = `plp_${familyCode}_${sizeCode || 'all'}_v${CACHE_VERSION}`;

    /* ----------------------------------------
       CACHE
    ---------------------------------------- */
    if (!cache[cacheKey]) {
      let siblings = [];

      const storageKey = `siblings_${cacheKey}`;
      const cached = sessionStorage.getItem(storageKey);

      if (cached) {
        siblings = JSON.parse(cached);
      } 
      /* ----------------------------------------
         FETCH + ASSIGN (PDP SAME LOGIC)
      ---------------------------------------- */
      else {
        const res = await fetch(`/search?q=${encodeURIComponent(familyCode)}*&type=product`);
        const html = await res.text();

        const doc = new DOMParser().parseFromString(html, 'text/html');
        const items = doc.querySelectorAll('.grid__item');

        items.forEach(item => {
          const link  = item.querySelector('.card__heading a');
          const img   = item.querySelector('img');
          const text  = item.textContent || '';

          if (!link) return;

          const title = link.textContent.trim();

          // -------------------------------
          // BASE + SIZE (same as PDP)
          // -------------------------------
          const base = title.split('-')[0]?.trim();
          const size = title
            .split('|')[0]
            ?.split('-')
            .pop()
            ?.trim();

          if (base !== familyCode) return;

          if (productType === 'FOOTWEAR' && sizeCode && size !== sizeCode) return;

          const handle = link.href.split('/products/')[1]?.split('?')[0];
          if (!handle) return;

          const available  = !text.includes('Sold out');
          const comingSoon = text.includes('SMART_TAG_COMINGSOON');

          // -------------------------------
          // AVAILABILITY RULES (same as PDP)
          // -------------------------------
          if (productType === 'FOOTWEAR') {
            if (plpComingSoon) {
              if (!available && !comingSoon) return;
            } else {
              if (!available) return;
            }
          } else {
            if (plpComingSoon) {
              if (!available && !comingSoon) return;
            } else {
              if (!available) return;
            }
          }

          siblings.push({
            title,
            handle,
            url: link.getAttribute('href'),
            image: img?.src || '',
            available,
            comingSoon
          });
        });

        sessionStorage.setItem(storageKey, JSON.stringify(siblings));
      }

      cache[cacheKey] = siblings;
    }

    /* ----------------------------------------
       RENDER (UNCHANGED)
    ---------------------------------------- */
    renderSiblings(card, cache[cacheKey], currentHandle);
  }
}

/* ===============================
   DRAG SCROLL (UNCHANGED)
================================ */

function initSiblingScroll(context = document) {
  context.querySelectorAll('.collection-siblings__grid').forEach(grid => {
    if (grid.dataset.scrollInit === 'true') return;
    grid.dataset.scrollInit = 'true';

    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;
    let hasDragged = false;

    grid.addEventListener('mousedown', e => {
      if (grid.closest('.collection-siblings')?.classList.contains('sibling-carousel')) {
        isDown = false;
        hasDragged = false;
        return;
      }
      e.stopPropagation();
      isDown = true;
      startX = e.pageX;
      scrollLeft = grid.scrollLeft;
      hasDragged = false;
      grid.classList.add('is-dragging');
      grid.querySelectorAll('a, img').forEach(el => el.style.pointerEvents = 'none');
    });

    /* MOBILE FIX */
    grid.addEventListener('touchstart', e => {
      e.stopPropagation();
    }, { passive: false });

    grid.addEventListener('touchmove', e => {
      e.stopPropagation();   // 👈 THIS is the main fix
    }, { passive: false });

    grid.addEventListener('touchend', e => {
      e.stopPropagation();
    });

    grid.addEventListener('mousemove', e => {
      if (!isDown) return;
      const dx = e.pageX - startX;
      if (Math.abs(dx) > 5) {
        hasDragged = true;
        grid.scrollLeft = scrollLeft - dx;
      }
    });

    const stop = () => {
      isDown = false;
      grid.classList.remove('is-dragging');
      setTimeout(() => {
        grid.querySelectorAll('a, img').forEach(el => el.style.pointerEvents = '');
      }, 50);
    };

    grid.addEventListener('mouseup', stop);
    grid.addEventListener('mouseleave', stop);

    grid.addEventListener('click', e => {
      if (hasDragged) {
        e.preventDefault();
        e.stopPropagation();
      }
    });
  });
}

/* ===============================
   CLICK HANDLER (UNCHANGED)
================================ */

document.addEventListener('click', e => {
  const btn = e.target.closest('.sibling-link');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  const url = btn.dataset.url;
  if (url) window.location.assign(url);
});

/* ===============================
   INIT + AJAX OBSERVER
================================ */

document.addEventListener('DOMContentLoaded', () => {
  initSiblingSwatches();
  initSiblingScroll();
});

const gridContainer = document.querySelector('#ProductGridContainer');
if (gridContainer) {
  new MutationObserver(() => {
    initSiblingSwatches(gridContainer);
    initSiblingScroll(gridContainer);
  }).observe(gridContainer, {
    childList: true,
    subtree: true
  });
}